// extracted by mini-css-extract-plugin
export var leftAlign = "_2e-2";
export var popper = "_2e-0";
export var subtitle = "_2e-1";